import { xor, union, difference } from 'lodash'
import { deepPatch } from '@/utils/generalUtils'

export const toggleArray = (array: any[], values: any[], force: boolean | null = null) => {
  if (force === true) return union(array, values)
  if (force === false) return difference(array, values)
  return xor(array, values)
}

export const toggleValue = (array: any[], value: any, force: boolean | null = null) =>
  toggleArray(array, [value], force)

export const toggleArrayInPlace = (array: any[], values: any[], force: boolean | null = null) =>
  deepPatch(array, toggleArray(array, values, force))

export const toggleValueInPlace = (array: any[], value: any, force: boolean | null = null) =>
  toggleArrayInPlace(array, [value], force)

export const sortById = (array: any[], sortOrder: string = 'asc') => {
  const multiplier = sortOrder === 'desc' ? -1 : 1
  return array.slice().sort((a, b) => multiplier * (parseInt(a.id) - parseInt(b.id)))
}

export function arrFilterPrefixes(arr: string[], prefixes: string[], removePrefix: boolean = false): string[] {
  return arr
    .map(item => {
      const prefix = prefixes.find(prefix => item.startsWith(prefix))
      return prefix ? { prefix, item } : null
    })
    .filter(Boolean)
    .map(({ prefix, item }: any) => (removePrefix ? item.slice(prefix.length).trim() : item))
}

export function arrExcludePrefixes(arr: string[], prefixes: string[]): string[] {
  return arr.filter((item: string) => {
    return !prefixes.some(prefix => item.startsWith(prefix))
  })
}

export function arrFindAndReplaceObject(arr, target, newItem): boolean {
  let replaced = false
  const targetEntries = Object.entries(target)

  if (targetEntries.length === 0) return false

  arr.forEach(item => {
    const isMatch = targetEntries.every(([key, value]) => item && typeof item === 'object' && item[key] === value)

    if (isMatch) {
      deepPatch(item, newItem)
      replaced = true
    }
  })

  return replaced
}
